// Generated by scripts/build_product_entry_rules.py; do not edit.
export const MONEY_DECIMALS = 2;
export const PRICE_DECIMALS = 2;
export const SALE_PRICE_DECIMALS = 0;
export const PRICE_INTEGER_PLACES = 5;
export const PRICE_MAXIMUM = 99999.99;
